import { api } from '.';
import {
  ICharacterPost,
  ICharacterPostPayload,
  ICommunityPost,
  IEFinderObject,
  IPagination,
} from '../model';
import { toQueryString } from '../utils/misc';

export const fetchPost = async (id: number) => {
  const { data } = await api.get<ICommunityPost>(`/communities/${id}/`);
  return data;
};

export const togglePostLike = async (id: number) => {
  const { data } = await api.post<{ isLiked: boolean }>(
    `/communities/${id}/like/`
  );
  return data;
};

export const fetchUserPosts = async (
  userId: number,
  page = 1,
  perPage = 20
) => {
  const { data } = await api.get<IPagination<ICommunityPost>>(
    `/users/${userId}/communities/${toQueryString({ page, perPage })}`
  );
  return data;
};

export interface ICommunityPayload
  extends Pick<ICommunityPost, 'isFixed' | 'content' | 'isCommentEnabled'> {
  picture?: IEFinderObject<'image'>;
}

export const fetchMyPosts = async (page = 1, perPage = 20) => {
  const { data } = await api.get<IPagination<ICommunityPost>>(
    `/users/me/communities/${toQueryString({ page, perPage })}`
  );
  return data;
};

export const fetchMyCommunityPost = async (id: number) => {
  const { data } = await api.get<ICommunityPost>(
    `/users/me/communities/${id}/`
  );
  return data;
};

export const postMyCommunityPost = async (payload: ICommunityPayload) => {
  const { data } = await api.post<ICommunityPost>(
    '/users/me/communities/',
    payload
  );
  return data;
};

export const patchMyCommunityPost = async ({
  id,
  ...payload
}: { id: number } & ICommunityPayload) => {
  const picture = payload.picture ?? null;

  const { data } = await api.patch<ICommunityPost>(
    `/users/me/communities/${id}/`,
    { ...payload, picture }
  );
  return data;
};

export const deleteMyCommunityPost = async (id: number) => {
  const { data } = await api.delete(`/users/me/communities/${id}/`);
  return data;
};

/* 캐릭터 커뮤니티 api */

export const fetchCharacterPost = async (id: number) => {
  const { data } = await api.get<ICharacterPost>(`/play/communities/${id}/`);
  return data;
};

export const fetchCharacterPosts = async (
  characterId: number,
  page = 1,
  perPage = 20
) => {
  const { data } = await api.get<IPagination<ICharacterPost>>(
    `/play/characters/${characterId}/communities/${toQueryString({
      page,
      perPage,
    })}`
  );
  return data;
};

export const postCharacterPost = async (payload: ICharacterPostPayload) => {
  const { data } = await api.post<ICharacterPost>(
    '/play/my-communities/',
    payload
  );
  return data;
};

export const patchCharacterPost = async ({
  postId,
  ...payload
}: { postId: number } & ICharacterPostPayload) => {
  const { data } = await api.patch<ICharacterPost>(
    `/play/my-communities/${postId}/`,
    {
      ...payload,
    }
  );
  return data;
};

export const deleteCharacterPost = async (id: number) => {
  const { data } = await api.delete(`/play/my-communities/${id}/`);
  return data;
};

export const toggleCharacterPostLike = async (id: number) => {
  const { data } = await api.post<{ isLiked: boolean }>(
    `/play/communities/${id}/like/`
  );
  return data;
};
